module.exports = __webpack_public_path__ + "media/images/flags/ro-1e4b89dbd367cc381281d60e8f088159.svg";